import { useEffect, useState } from "react";

const links = [
  { label: "Journeys", href: "#journeys" },
  { label: "Wilderness", href: "#wilderness" },
  { label: "Stories", href: "#stories" },
  { label: "Field Guide", href: "#guide" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-stone-100"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex items-center justify-between px-8 lg:px-14 py-5">
        <a href="#" className="flex items-center gap-2.5 group cursor-pointer">
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[#1f3a25] text-white">
            <i className="ri-leaf-line text-base"></i>
          </span>
          <span className="font-display text-[22px] tracking-[0.04em] text-deepgreen">
            Wild&nbsp;Horizons
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                className="font-serif text-[12px] uppercase tracking-[0.28em] text-deepgreen-soft hover:text-[#1f3a25] transition-colors cursor-pointer whitespace-nowrap"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-4">
          <button className="text-deepgreen-soft hover:text-[#1f3a25] transition-colors cursor-pointer w-9 h-9 flex items-center justify-center whitespace-nowrap">
            <i className="ri-search-line text-lg"></i>
          </button>
          <button className="px-5 py-2 rounded-full border border-[#1f3a25]/30 font-serif text-[12px] uppercase tracking-[0.24em] text-deepgreen hover:bg-[#1f3a25] hover:text-white hover:border-[#1f3a25] transition-all cursor-pointer whitespace-nowrap">
            Plan a Trip
          </button>
        </div>

        <button className="md:hidden w-10 h-10 flex items-center justify-center text-deepgreen cursor-pointer">
          <i className="ri-menu-line text-2xl"></i>
        </button>
      </nav>
    </header>
  );
}